const SkuTooltip = ({ tooltipId, sku }) => {
  if (sku === null || sku === '') {
    return (
      <div className="sku-wrapper">
        <span>&nbsp;</span>
      </div>
    );
  }

  return (
    <div
      className="sku-wrapper"
      onClick={() => {
        navigator.clipboard.writeText(sku);
        window.editTooltip(tooltipId);
      }}
    >
      <span
        id={tooltipId}
        className="clinker__share sku"
        data-tooltip-id="sku-copy"
        data-tooltip-content="Нажмите чтобы скопировать артикул"
      >
        <i className="icon sku" />
        <span>Арт.: {sku}</span>
      </span>
    </div>
  );
};

export default SkuTooltip;
